import axios from "axios";
import customConfig from "../config";
import store from "../store";
import { setAlert } from "../action/alert";

// Default timeout for all requests (can be overridden per-request)
axios.defaults.timeout = 30000;

const ResponseInterceptor = () => {
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      // Allow axios cancellation errors to propagate so callers can handle them correctly
      if (axios.isCancel && axios.isCancel(error)) {
        return Promise.reject(error);
      }

      // Handle timeout errors
      const errorMessage = error?.message?.toLowerCase?.() || '';
      if (error.code === 'ECONNABORTED' || errorMessage.includes('timeout') || errorMessage.includes('timed out')) {
        console.error('Request timeout:', error.config?.url);
        error.isTimeout = true;
        error.userMessage = customConfig.TIMEOUT_ERROR;
      }

      // Handle network errors
      if (!error.response && !error.isTimeout) {
        console.error('Network error:', error.config?.url);
        error.isNetworkError = true;
        error.userMessage = customConfig.NETWORK_ERROR;
      }

      // Handle 401 unauthorized
      if (
        error.response &&
        401 === error.response.status &&
        window.location.pathname !== "/"
      ) {
        store.dispatch(setAlert(customConfig.sessionExpireMsg, "danger"));
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("authInfo");
        localStorage.removeItem("userRoles");
        localStorage.removeItem("userLevel");
        localStorage.removeItem("loggedInUserName");
        window.location = "/";
      }

      // Updated due to axios version upgrade
      // IMPORTANT: reject so axios knows the request failed
      return Promise.reject(error);
    }
  );
};

export default ResponseInterceptor;
